// React
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
// Components
import DeleteOrderWhimDialog from './DeleteOrderWhimDialog'
// Actions
import dialogsManagerActions from '../../redux/actions/dialogsManager.actions'

const mapStateToProps = (
  { deleteOrderWhimDialogReducer: { open, orderId, whimId } },
  { intl: { formatMessage } },
) => {
  const confirm = formatMessage({
    id: 'globals.confirm',
  })
  const description = formatMessage({
    id: 'deleteOrderWhim.description',
  })
  const title = formatMessage({
    id: 'deleteOrderWhim.title',
  })

  return {
    confirm,
    title,
    description,
    open,
    orderId,
    whimId,
  }
}
const mapDispatchToProps = {
  onClose: dialogsManagerActions.back,
  onBack: dialogsManagerActions.back,
  onClickDelete: dialogsManagerActions.RemoveOrderWhim,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DeleteOrderWhimDialog),
)
